<template>
  <div
    class="fixedRel"
    :style="{
      width: isGraphic ? '100%' : '350px',
    }"
  >
    <div>
      <div class="rel_title">Relatórios</div>
      <v-expansion-panels
        v-if="userRelatorios.length > 0"
        accordion
        focusable
        v-model="panel"
        :active-class="'active_panel'"
      >
        <v-expansion-panel
          v-for="(categoria, i) in Object.keys(relatorios)"
          :key="i"
        >
          <v-expansion-panel-header>
            {{ categoria }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col>
                <v-card
                  :class="`mt-3 ${
                    relatorio && relatorio.id === item.id ? 'active' : 'card'
                  }`"
                  :id="'v-card-' + item.id"
                  v-for="(item, index) in relatorios[categoria].sort(compare)"
                  :key="index"
                  outlined
                  @click="goToRelatorio(item.id)"
                >
                  <relatorio-card
                    :relatorio="item"
                    v-if="exibirRelatorio(item)"
                  ></relatorio-card>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="noRelatorio" v-else>Nenhum relatório encontrado</div>
    </div>
  </div>
</template>
<script>
import RelatorioCard from "./components/relatorioCard.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { RelatorioCard },
  props: {
    relatorios: Object,
    relatorio: Object,
    isGraphic: Boolean,
  },
  data() {
    return {
      panel: 0,
      userRelatorios:
        JSON.parse(localStorage.getItem("user")).grupo.relatorioAdm || [],
    };
  },
  computed: {
    ...mapGetters(["isSala", "isAT", "isParceiro"]),
  },
  watch: {
    relatorio: {
      handler() {
        this.getActivePanel();
      },
      deep: true,
    },
  },
  methods: {
    compare(a, b) {
      if (a["title"] < b["title"]) {
        return -1;
      }
      if (a["title"] > b["title"]) {
        return 1;
      }
      return 0;
    },
    goToRelatorio(id) {
      this.$router.push("/dashboard-administrativo2/relatorio/" + id);
    },
    exibirRelatorio(relatorio) {
      if (relatorio.exibirEm && relatorio.exibirEm.length > 0) {
        if (relatorio.exibirEm.some((item) => this[item])) return true;
        return false;
      }

      return true;
    },
    getActivePanel() {
      if (!this.relatorio) { this.panel = 0; return; }
      this.relatorio
        ? Object.keys(this.relatorios).forEach((item, index) => {
            if (item == this.relatorio.category) this.panel = index;
          })
        : (this.panel = 0);

      setTimeout(() => {
        if (!this.relatorio) return;
        const card = document.getElementById(`v-card-${this.relatorio.id}`);
        const panel = document.querySelector(
          ".v-expansion-panel--active .v-expansion-panel-content"
        );
        if (card && panel) panel.scrollTop = card.offsetTop - 200;
      }, 500);
    },
  },
  mounted() {
    if (this.userRelatorios.length > 0) this.getActivePanel();
  },
};
</script>
<style scoped lang="scss">
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.card:last-of-type {
  margin-bottom: 12px;
}
.active_panel {
  .v-expansion-panel-content {
    max-height: 300px;
    overflow-y: auto;
  }
}
.no-card {
  border: 2px dashed var(--corPrimaria);
  height: 326px;
  width: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.active {
  background: var(--corPrimaria);
  color: #fff !important;
  .text-card {
    color: #e5e1e1;
  }
  .title-card {
    color: #e5e1e1;
  }
}
.fixedRel {
  width: 350px;
}

.addRel {
  /* border: 1px solid var(--corPrimaria);
  border-radius: 50%;
  width: 24%;
  height: 20%; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.rel_title {
  background: var(--corPrimaria);
  color: #fff;
  padding: 1rem;
  text-align: center;
}

.noRelatorio {
  padding: 1rem;
  text-align: center;
  border: 1px solid #00000036;
}
</style>
